/**
 * Cache local da lista de pagamentos por usuário (localforage).
 */

import localforage from 'localforage';
import type { Payment } from '@/core/domain';

const CACHE_KEY = 'retornaar:payments-by-user';

export interface PaymentsLocalDataSource {
  /** `null` = não há cache para esse usuário. */
  getListByUserId(userId: string): Promise<Payment[] | null>;
  setListByUserId(userId: string, payments: Payment[]): Promise<void>;
  clearListByUserId(userId: string): Promise<void>;
}

const store = localforage.createInstance({ name: 'retornaar', storeName: 'payments' });

async function getMap(): Promise<Record<string, Payment[]>> {
  const raw = await store.getItem<Record<string, Payment[]>>(CACHE_KEY);
  return raw ?? {};
}

async function setMap(map: Record<string, Payment[]>): Promise<void> {
  await store.setItem(CACHE_KEY, map);
}

export class PaymentsLocalForageDataSource implements PaymentsLocalDataSource {
  async getListByUserId(userId: string): Promise<Payment[] | null> {
    const map = await getMap();
    return Object.prototype.hasOwnProperty.call(map, userId) ? map[userId]! : null;
  }

  async setListByUserId(userId: string, payments: Payment[]): Promise<void> {
    const map = await getMap();
    map[userId] = payments;
    await setMap(map);
  }

  async clearListByUserId(userId: string): Promise<void> {
    const map = await getMap();
    if (!Object.prototype.hasOwnProperty.call(map, userId)) return;
    const next = { ...map };
    delete next[userId];
    await setMap(next);
  }
}
